<!-- start banner Area -->
<section class="banner-area relative" id="home">
  <div class="overlay overlay-bg"></div>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="about-content col-lg-12">
        <h1 class="text-white">
          Portail utilisateur
        </h1>
        <p class="text-white link-nav"><a routerLink="">Offres d'emploi </a> <span
            class="lnr lnr-arrow-right"></span>
          <a routerLink=""> Portail</a>
        </p>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Start service Area -->
<section class="service-area section-gap" id="service">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="col-md-6 pb-40 form-area">
        <div class="row text-center">
          <div class="col-lg-12 mb-4">
            <a [routerLink]="['/connexion']"><button
                class="btn-portail-start">CANDIDATS</button></a>
          </div>
          <div class="col-lg-12 mb-4">
            <a [routerLink]="['/connexion']"><button
                class="btn-portail-start">CONSULTANTS</button></a>
          </div>
          <div class="col-lg-12 mb-4">
            <a [routerLink]="['/connexion']"><button class="btn-portail-start">ENTREPRISES</button></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End service Area -->